import { Component, Story, Knobs, Accents } from './DocTypes';

const PlaygroundKnobs: Knobs = {
  accent: {
    default: 'keppel',
    editor: 'dropdown',
    editorOptions: [''].concat(Accents),
  },
  disabled: {
    default: false,
    editor: 'checkbox',
  },
  'colour-scheme': {
    editor: 'dropdown',
    editorOptions: ['light', 'dark', ''],
    default: '',
  },
  device: {
    editor: 'dropdown',
    editorOptions: ['mobile', 'desktop', ''],
    default: '',
  },
};

const Playground: Story = {
  title: 'Playground',
  description: 'A fan menu for mobile apps',
  coreComponent_v3: {
    html: `<div style="min-width: 375px; display: flex; height: 100%; flex-direction: column; justify-content: flex-end; padding: 20px 0; box-sizing: border-box;">
    <tag3-mobile-fan-menu style="margin-left: 45%" {{...knobs}}>
        <tag3-mobile-fan-menu-item icon="Camera" name="camera"></tag3-mobile-fan-menu-item>
        <tag3-mobile-fan-menu-item icon="Doc" name="doc"></tag3-mobile-fan-menu-item>
        <tag3-mobile-fan-menu-item icon="Edit" name="edit"></tag3-mobile-fan-menu-item>
        <tag3-mobile-fan-menu-item icon="Code" name="code"></tag3-mobile-fan-menu-item>
        <tag3-mobile-fan-menu-item icon="AlarmClock" name="alarm"></tag3-mobile-fan-menu-item>
    </tag3-mobile-fan-menu>
</div>`,
    knobs: PlaygroundKnobs,
  },
  reactWrapper_v3: {
    jsx: `<div style={{ minWidth: "375px", display: "flex", height: "100%", flexDirection: "column", justifyContent: "flex-end", padding: "20px 0", boxSizing: "border-box" }}>
  <Tag3MobileFanMenu style={{marginLeft: "45%"}} {{...knobs}}>
      <Tag3MobileFanMenuItem icon="Camera" name="camera"></Tag3MobileFanMenuItem>
      <Tag3MobileFanMenuItem icon="Doc" name="doc" ></Tag3MobileFanMenuItem>
      <Tag3MobileFanMenuItem icon="Edit" name="edit" ></Tag3MobileFanMenuItem>
      <Tag3MobileFanMenuItem icon="Code" name="code"></Tag3MobileFanMenuItem>
      <Tag3MobileFanMenuItem icon="AlarmClock" name="alarm"></Tag3MobileFanMenuItem>
  </Tag3MobileFanMenu>
</div>`,
    knobs: PlaygroundKnobs,
  },
};

const MultipleItemsKnobs: Knobs = {
  items: {
    default: '5',
    editor: 'dropdown',
    editorOptions: ['2', '3', '4', '5'],
  },
};

const MultipleItems: Story = {
  title: 'Multiple Items',
  description:
    'Fan menu with multiple items. You can select the number of items (between 2 and 5).',
  reactWrapper_v3: {
    jsx: `<Example {{items}}/>`,
    parentJSX: `const Example = ({items}) => {
      const icons = ['Camera', 'Doc', 'Edit', 'Code', 'AlarmClock'].slice(0,items);

      return (
        <div style={{ minWidth: "375px", display: "flex", height: "100%", flexDirection: "column", justifyContent: "flex-end", padding: "20px 0", boxSizing: "border-box" }}>
          <Tag3MobileFanMenu style={{marginLeft: '45%'}} {{...knobs}}>
            {icons.map(icon => (<Tag3MobileFanMenuItem icon={icon} name={icon}></Tag3MobileFanMenuItem>))}
          </Tag3MobileFanMenu>
        </div>
      );
    }`,
    knobs: MultipleItemsKnobs,
  },
};

const UpdateItems: Story = {
  title: 'Update Items',
  description:
    'Fan menu with multiple items. You can dynamically add/remove items using te buttons, to display between 1-5 fan items.',
  coreComponent_v3: {
    html: `<div style="min-width: 375px; display: flex; height: 100%; flex-direction: column; justify-content: flex-end; padding: 20px 0; box-sizing: border-box;">
    <div style="margin:20px;">
        <tag3-button class="addBtn">Add fan menu item</tag3-button>
        <tag3-button class="removeBtn">Remove fan menu item</tag3-button>
    </div>  
    <tag3-mobile-fan-menu style="margin-left: 45%" {{...knobs}}></tag3-mobile-fan-menu>
</div>`,
    js: `
    var items=[
      {name: "camera", icon: "Camera"},
      {name: "doc", icon: "Doc"},
      {name: "edit", icon:"Edit"},
      {name: "code", icon: "Code"},
      {name: "alarm", icon: "AlarmClock"}
    ];
    var fan = document.querySelector('tag3-mobile-fan-menu');
    fan.items = [
      {name: "camera", icon: "Camera"},
      {name: "doc", icon: "Doc"},
      {name: "edit", icon:"Edit"},
      {name: "code", icon: "Code"},
    ];

    var addBtn = document.querySelector('.addBtn');
    var removeBtn = document.querySelector('.removeBtn');

    addBtn.addEventListener('buttonClick',function() {
      var newItemNumber = fan.items.length;
      if(newItemNumber < items.length){
        fan.items = fan.items.concat(items[newItemNumber]);
      }
    });

    removeBtn.addEventListener('buttonClick',function() {
      if(fan.items.length > 1){
        fan.items = fan.items.slice(0,-1);
      }
    });
    `,
  },
  reactWrapper_v3: {
    jsx: `<Example/>`,
    parentJSX: `
    const Example = () => {
      const [selectedItems, setSelectedItems]=React.useState([
        {name: "camera", icon: "Camera"},
        {name: "doc", icon: "Doc"},
        {name: "edit", icon:"Edit"},
        {name: "code", icon: "Code"}
      ]);

      const items=[
        {name: "camera", icon: "Camera"},
        {name: "doc", icon: "Doc"},
        {name: "edit", icon:"Edit"},
        {name: "code", icon: "Code"},
        {name: "alarm", icon: "AlarmClock"}
      ];

      const handleAddButtonClick = () => {
        if(selectedItems.length < items.length) {
          setSelectedItems([...selectedItems, items[selectedItems.length]]);
        }
      }

      const handleRemoveButtonClick = () => {
        const newItems = [...selectedItems];
        if(newItems.length > 1){
          newItems.pop()
          setSelectedItems(newItems);
        }
      }

      return (
        <div style={{ minWidth: "375px", display: "flex", height: "100%", flexDirection: "column", justifyContent: "flex-end", padding: "20px 0", boxSizing: "border-box" }}>
          <div style={{margin:"20px"}}>
            <Tag3Button onButtonClick={handleAddButtonClick}>Add fan menu item</Tag3Button>
            <Tag3Button onButtonClick={handleRemoveButtonClick}>Remove fan menu item</Tag3Button>
          </div>  
          <Tag3MobileFanMenu style={{marginLeft: '45%'}}
            items={selectedItems}>
          </Tag3MobileFanMenu>
        </div>
      );
    }
    `,
  },
};

export const TagFanMenuItemDocs: Component = {
  type: 'component',
  name: 'fan-menu-item',
  description: 'Renders a mobile fan menu item',
  mobileFriendly: true,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'name',
      description: 'The fan menu item unique name',
      type: 'string',
    },
    {
      name: 'accent',
      description: 'The colour of the button background.',
      type: 'string',
    },
    {
      name: 'icon',
      description: 'The icon inside the item',
      type: 'Icon',
    },
    {
      name: 'disabled',
      description: 'Whether the item is disabled',
      type: 'boolean',
    },
    {
      name: 'colour-scheme',
      description:
        ' Dark mode (theme) control. Undefined for normal browser control. Dark | Light to force respective styling regardless of browser setting.',
      type: 'dark | light',
    },
    {
      name: 'device',
      description: 'Set preferred styling theme for device type.',
      type: 'desktop | mobile',
      default: 'mobile',
    },
  ],
  reactPropOverrides: [],
  events: [
    {
      name: 'menuItemClick',
      description: 'Triggers when a fan menu item is clicked',
      parameters: [
        {
          name: 'name',
          description: 'The name attribute of the fan menu item',
          type: 'string',
        },
      ],
    },
  ],
  methods: [],
  stories: [],
};

export const TagMobileFanMenuDocs: Component = {
  type: 'component',
  name: 'mobile-fan-menu',
  description: 'Renders a mobile fan menu',
  mobileFriendly: true,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'accent',
      description: 'The accent of the selected option',
      type: 'Accent',
    },
    {
      name: 'disabled',
      description: 'Whether the nav is disabled',
      type: 'boolean',
    },
    {
      name: 'items',
      description: 'Array used in generating fan-menu-items. Can be set/ edited after load.',
      type: 'ITagMobileFanMenuItem[]',
    },
    {
      name: 'colour-scheme',
      description:
        'Dark mode (theme) control. Undefined for normal browser control. Dark | Light to force respective styling regardless of browser setting.',
      type: 'dark | light',
    },
    {
      name: 'device',
      description: 'Set preferred styling theme for device type.',
      type: 'desktop | mobile',
      default: 'mobile',
    },
  ],
  reactPropOverrides: [],
  events: [
    {
      name: 'menuItemClick',
      description: 'Triggers when a fan menu item is clicked',
      parameters: [
        {
          name: 'name',
          description: 'The name attribute of the fan menu item',
          type: 'string',
        },
      ],
    },
  ],
  methods: [],
  stories: [Playground, MultipleItems, UpdateItems],
  childComponents: [TagFanMenuItemDocs],
};
